import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyEnum } from '@magieno/common';
import { Locale } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  Quebec2022TaxQuestionnaireChildOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire-child.options';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';

@Component({
  selector: 'app-quebec-2022-tax-questionnaire-child',
  templateUrl: './quebec-2022-tax-questionnaire-child.component.html',
  styleUrls: ['./quebec-2022-tax-questionnaire-child.component.scss'],
  standalone: false,
})
export class Quebec2022TaxQuestionnaireChildComponent {

  @Input()
  childForm: AdvancedFormGroup<Quebec2022TaxQuestionnaireChildOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<MainSpouseQuebec2022TaxQuestionnaireOptions>;

  constructor(private readonly translateService: TranslateService) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }
}

